/**
 * @description OTP 使用情境用
*/
export enum SactionType {
  /** 會員登入 */
  Login = '1',
  /** 會員註冊 */
  Signup = '2',
  /** 投保 */
  Insurce = '3',
  /** 續保驗證 */
  RenewalVerify = '4'
}
